import {Field as SimpleField, FieldRenderProps} from 'react-final-form';
import useForm from '../../../../hooks/useForm';
import {Props} from './types';

const Field = <T, >({children, onChange, ...restProps}: Props<T, FieldRenderProps<T>>): JSX.Element => {
    const form = useForm();

    return (
        <SimpleField {...restProps}>
            {props => {
                const {input, meta, ...restProps} = props;
                // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
                const {checked, ...restInput} = input;
                const {valid: isValid, error: errorMessage, submitError: submissionErrorMessage, touched: isTouched} = meta;

                return children({
                    ...restInput,
                    ...restProps,
                    isValid,
                    errorMessage: errorMessage || submissionErrorMessage,
                    isTouched,
                    onChange: event => {
                        if (onChange) {
                            onChange(event, form);
                        }

                        if (!event?.defaultPrevented) {
                            input.onChange(event);
                        }
                    }
                });
            }}
        </SimpleField>
    );
};

export default Field;
